import MainLayout from "../MainLoyout/MainLayout";
import {Box, Container, FormControl, Grid, InputLabel, Paper, Select} from "@mui/material";
import Title from "../Title";
import Api from "../../Services/Api";
import React, {useEffect, useState} from "react";
import Skeleton from "@mui/material/Skeleton";
import {DataGrid} from "@mui/x-data-grid";


const SupplyFeeds = () => {

    const [supplyDemand, setSupplyDemand] = useState(false);
    const [loading, setLoading] = useState(true);

    const columns = [

        {
            field: "demand",
            headerName: "Demand",
            minWidth: 150,
            type: 'text',
            editable: false,
            flex: 0.6,
            valueGetter: (params) => params.row?.demand_feed?.user?.name
        },
        {
            field: "supply",
            headerName: "Supply",
            minWidth: 150,
            type: 'text',
            editable: false,
            flex: 0.6,
            valueGetter: (params) => params.row?.supply_feed?.user?.name
        },

        {
            field: "demand_feed_id",
            headerName: "Demand Feed Id",
            minWidth: 100,
            type: 'number',
            editable: false,
            flex: 0.4
        },
        {
            field: "supply_feed_id",
            headerName: "Supply Feed Id",
            minWidth: 100,
            type: 'number',
            editable: false,
            flex: 0.4
        },
        {
            field: "needle",
            headerName: "needle",
            minWidth: 100,
            type: 'text',
            editable: false,
            flex: 0.4,
            valueGetter: (params) => params.row?.demand_feed?.needle
        },
        {
            field: "capping",
            headerName: "Capping",
            minWidth: 50,
            type: 'number',
            editable: false,
            flex: 0.2
        }
    ];

    const LoadingSkeleton = () => (
        <Box
            sx={{
                height: "max-content"
            }}
        >
            {[...Array(20)].map((item, key) => (
                <Skeleton key={key} variant="rectangular" sx={{my: 2, mx: 1}}/>
            ))}
        </Box>
    );


    useEffect(() => {

        Api.supplydemand().then(r => {
            setSupplyDemand(r)
            setLoading(false)
        })
    }, []);


    return (
        <MainLayout>

            <Container maxWidth="xl" sx={{mt: 4, mb: 4}}>
                <Grid container spacing={3}>

                    <Grid item xs={12}>
                        <Paper sx={{p: 2, display: 'flex', flexDirection: 'column'}}>
                            <Title>Supply - Demand Config</Title>

                            <div style={{display: 'flex', height: '100%'}}>
                                <div style={{flexGrow: 1}}>
                                    <DataGrid

                                        rows={!loading ? supplyDemand:[]}
                                        columns={columns}
                                        pageSize={50}
                                        //autoHeight={true}
                                        getRowId={(row) => row.supply_feed_id+'-'+row.demand_feed_id}

                                        disableSelectionOnClick
                                        disableColumnSelector
                                        sx={{
                                            mt: 2,
                                            mb: 2,
                                            height: '600px'
                                        }}
                                        density={"compact"}
                                        components={{
                                            LoadingOverlay: LoadingSkeleton,
                                        }}
                                        loading={loading}
                                    />
                                </div>
                            </div>
                        </Paper>
                    </Grid>
                </Grid>


            </Container>


        </MainLayout>
    )
}

export default SupplyFeeds